import axios from 'axios';
import { Dispatch } from 'redux'

const applicationSettings = require('../../translations/applicationSettings.json')

export function loadReports(webapiUrl, clientName, token) {
    var config = {
        headers: { 'Authorization': "bearer " + token }
    };

    var platform = "dev";
    var currentUrl = window.location.href;
    if (currentUrl.includes("localhost")) {
        platform = "dev";
    }
    else if (currentUrl.includes("dev")) {
        platform = "dev";
    }
    else if (currentUrl.includes("uat")) {
        platform = "uat";
    }
    else if (currentUrl.includes("test")) {
        platform = "test";
    }
    else {
        platform = "prod";
    }

    return function (dispatch: Dispatch<any>) {
        return axios.get(webapiUrl + '/api/powerBI/Geti4PowerBIReports?clientName=' + clientName + '&platform=' + platform, config)
            .then(res => {
                dispatch(loadReportSuccess(res.data))
            })
            .catch(error => {
                throw error
            });
    }
}

export function loadReportSuccess(data) {
    return { type: 'load_report_success', data };
}

export function getApiToken(webapiUrl) {
    return function (dispatch: Dispatch<any>) {
        return axios.get(webapiUrl + '/api/BiService/GetPowerBIApiToken')
            .then(res => {
                dispatch(getApiTokenSuccess(res.data))
            })
            .catch(error => { throw error });
    }
}

export function getApiTokenSuccess(token) {
    return { type: 'power_bi_api_token_success', token };
}


export function getFNTDashboards(webapiUrl) {
    return function (dispatch: Dispatch<any>) {
        return axios.get(webapiUrl + '/api/BiService/GetFNTDashboards')
            .then(res => {
                dispatch(getFNTDashboardsSuccess(res.data))
            })
            .catch(error => { throw error });
    }
}

export function getFNTDashboardsSuccess(fntDashboards) {
    return { type: 'fnt_dashboards', fntDashboards };
}

export function getFNTToken(webapiUrl) {
    return function (dispatch: Dispatch<any>) {
        return axios.get(webapiUrl + '/api/BiService/GetFNTToken')
            .then(res => {
                dispatch(getFNTTokenSuccess(res.data))
            })
            .catch(error => { throw error });
    }
}

export function getFNTTokenSuccess(token) {
    return { type: 'fnt_user_token', token };
}


export function getUserToken(webapiUrl) {
    return function (dispatch: Dispatch<any>) {
        return axios.post(webapiUrl + '/api/Authentication', { 'userName': 'pbiserviceadmin@i4-insight.com', 'password': 'i4@srv1ce@adm2'})
            .then(res => {
                dispatch(getUserTokenSuccess(res.data))
            })
            .catch(error => { throw error });
    }
}

export function getUserTokenSuccess(userToken) {
    return { type: 'user_token_success', userToken };
}


export function getReport(workspaceId, reportId, webapiUrl, token) {
    var config = {
        headers: { 'Authorization': "bearer " + token }
    };
    return function (dispatch: Dispatch<any>) {
        return axios.post(webapiUrl + '/api/powerBI/GetReport', { 'clientName': 'test', 'workspaceId': workspaceId, 'reportId': reportId }, config)
            .then(res => {
                dispatch(getReportSuccess(res.data))
            })
            .catch(error => { throw error });
    }
}

export function getReportSuccess(report) {
    return { type: 'get_report_success', report };
}


export function getPortParameters(webapiUrl, clientName, username, token) {
    var config = {
        headers: { 'Authorization': "bearer " + token }
    };
    return function (dispatch: Dispatch<any>) {
        return axios.get(webapiUrl + '/api/Bunker/GetPortPartameters?clientName=' + clientName + '&username=' + username, config)
            .then(res => {
                dispatch(getPortParametersSuccess(res.data))
            })
            .catch(error => { throw error });
    }
}

export function getPortParametersSuccess(portParameters) {
    return { type: 'get_port_parameters_success', portParameters };
}






// WEBPACK FOOTER //
// ./src/store/actions/powerBIActions.tsx